import { useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ImageIcon, FileText } from "lucide-react";

export const ProjectModal = ({ open, onOpenChange, project }) => {
  useEffect(() => {
    const lenis = window.__lenis;
    if (!lenis) return;
    if (open) lenis.stop();
    else lenis.start();
    return () => lenis.start();
  }, [open]);

  if (!project) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={`project-modal-${project.id}`}
        data-lenis-prevent
        onWheel={(e) => e.stopPropagation()}
        className="max-w-3xl w-[92vw] max-h-[88vh] overflow-y-auto overscroll-contain rounded-3xl border-white/10 bg-[#0a0a0a] text-white p-0 [&>button]:text-white/60 [&>button]:hover:text-white [&>button]:top-5 [&>button]:right-5"
      >
        <div className="relative h-52 md:h-64 overflow-hidden rounded-t-3xl">
          <img src={project.image} alt={project.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/40 to-transparent" />
          <p className="absolute bottom-5 left-8 font-tech text-[10px] tracking-[0.35em] uppercase text-[#FF66B2]">{project.kicker}</p>
        </div>
        <div className="px-8 pb-10">
          <DialogTitle className="font-display italic text-3xl md:text-4xl">{project.title}</DialogTitle>
          <DialogDescription className="text-white/65 text-base leading-relaxed mt-3">{project.summary}</DialogDescription>

          <div className="mt-8 space-y-4">
            {project.sections.map((s) => (
              <div key={s.heading} className="rounded-2xl border border-dashed border-white/15 bg-white/[0.02] p-5" data-testid={`project-modal-section-${s.heading.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-[#FF66B2] flex items-center gap-2">
                  <FileText size={12} strokeWidth={1.5} /> {s.heading}
                </p>
                <p className="text-white/55 text-sm leading-relaxed mt-3">{s.body}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-3 gap-3">
            {[1, 2, 3].map((n) => (
              <div key={n} className="aspect-[4/3] rounded-2xl border border-dashed border-white/15 bg-black/40 flex flex-col items-center justify-center gap-2 text-white/30" data-testid={`project-modal-media-slot-${n}`}>
                <ImageIcon size={18} strokeWidth={1.25} />
                <span className="font-tech text-[9px] tracking-[0.3em] uppercase">Coming soon</span>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
